import { buildColumnOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/columnConfig'
import { buildBarOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/barConfig'
import { buildPieOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/pieConfig'
import { buildStackedColumnOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/stackedColumnConfig'
import { buildStackedBarOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/stackedBarConfig'
import { buildAreaOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/areaConfig'
import { buildScatterOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/scatterConfig'
import { buildBubbleOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/bubbleConfig'
import { buildSunburstOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/sunburstConfig'
import { buildTreemapOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/treemapConfig'
import { buildEmdLineOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/emdLineConfig'
import {
  buildDataLabColumnsOptions,
  buildDataLabStackedOptions,
  buildDataLabBColumnsOptions,
  buildDataLabBStackedOptions
} from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/dataLabColumnsConfig'

const CHART_BUILDERS = {
  respondents: buildColumnOptions,
  percents: buildColumnOptions,
  brespondents: buildBarOptions,
  bpercents: buildBarOptions,
  pie: buildPieOptions,
  stacked_pie: buildStackedColumnOptions,
  stacked_respondents: buildStackedColumnOptions,
  stacked_percents: buildStackedColumnOptions,
  stacked_brespondents: buildStackedBarOptions,
  stacked_bpercents: buildStackedBarOptions,
  area: buildAreaOptions,
  scatter: buildScatterOptions,
  bubble: buildBubbleOptions,
  sunburst: buildSunburstOptions,
  treemap: buildTreemapOptions,
  emdline: buildEmdLineOptions,

  // Data Lab Columns (grouped/stacked × column/bar)
  dl_columns: buildDataLabColumnsOptions,
  dl_stacked: buildDataLabStackedOptions,
  dl_bcolumns: buildDataLabBColumnsOptions,
  dl_bstacked: buildDataLabBStackedOptions
}

export const getChartBuilder = chartMode => CHART_BUILDERS[chartMode] || null

// The chart a report draws when it names none of its own
const DEFAULT_MODE = 'respondents'

// A report can carry a mode a given question has no chart for -- a word cloud or a map set for the
// whole page, a mode saved before the question's type stopped offering it. Such a question draws the
// report's default chart where it offers that, else the first chart it does offer, rather than none.
export const resolveDrawableMode = (chartMode, chartModeTypes = []) => {
  if (getChartBuilder(chartMode)) return chartMode

  const offered = (chartModeTypes ?? []).filter(mode => getChartBuilder(mode))
  return offered.includes(DEFAULT_MODE) ? DEFAULT_MODE : (offered[0] ?? chartMode)
}
